App.prototype.showCollapse = function(id) {
	
	if (!id || id == '#' || id.indexOf('=') > -1) {
		return;
	}
	
	var panel = $(id + ".collapse," + id + '-panel.collapse');
	
	if (panel.length) {
		panel.collapse('show');
		this.scrollTo && this.scrollTo(panel.parent().parent());
	}
}

App.addModule(function(app) {

    app.on('loaded', () => {

	    $(document).on('show.bs.collapse', '[data-collapse-group]', function() {
		    
		    var trigger = $(this);
		    
		    var group = trigger.data('collapse-group');
		    
		    trigger.closest(group).find('.collapse').collapse('hide');
	    });

        $(document).on('shown.bs.collapse', function(event) {
            $(event.target).find('input[autofocus]').focus()
        });
	    
	    $(window).on('hashchange', function() {
		    app.showCollapse(window.location.hash);
	    });
	    
	    app.showCollapse(window.location.hash);
    })
})
